import PopoverContainer from "../../components/uiKits/popover";

const Popover = () => {
  return <PopoverContainer />;
};

export default Popover;
